
export enum RuleShmEntityTypeCd {
	ACCESSORIAL = 'Accessorial',
	COMMODITY = 'Commodity',
	SUPP_REF_NBR = 'SuppRefNbr'}

